exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c93d9a02","scoped":false,"hasInlineConfig":false}!./~/postcss-loader!./~/sass-loader/lib/loader.js!./app/components/account-about-modal/style.scss
// module id = 255
// module chunks = 0